import React from 'react';
import { MenuItemProps, MenuItem } from './MenuItem';
import { Flex, TextV2 } from '@withjoy/joykit';
import { pxToRem } from '@withjoy/joykit/theme';
import { NewBadge } from '@apps/admin/routes/Dashboard/components/DashboardContentV2/PrimaryDashboardContent/ProductRowItem/ProductRowItem.styles';

export type MenuSectionProps = {
  headerText?: string;
  items: MenuItemProps[];
  newPillText?: string;
  openSubmenu?: (items: Omit<MenuSectionProps, 'openSubmenu' | 'onClose'>[]) => void;
  onClose?: () => void;
};

export const MenuSection: React.FC<MenuSectionProps> = ({ items, headerText, openSubmenu, newPillText, onClose }) => {
  return (
    <Flex
      flexDirection="column"
      paddingLeft={pxToRem(12)}
      paddingRight={pxToRem(12)}
      overflowY="auto"
      maxWidth={pxToRem(320)}
    >
      {headerText && (
        <TextV2
          typographyVariant={'hed2'}
          paddingTop={pxToRem(24)}
          paddingBottom={pxToRem(12)}
          paddingLeft={pxToRem(16)}
        >
          {headerText}
        </TextV2>
      )}
      {items.map((item, i) => (
        <MenuItem
          expands={!!item.subItems}
          key={i}
          {...item}
          openSubmenu={openSubmenu}
          onClose={onClose}
        />
      ))}
      {newPillText && (
        <NewBadge
          color="#FFF"
          marginLeft={pxToRem(8)}
          typographyVariant={'label3'}
        >
          {newPillText}
        </NewBadge>
      )}
    </Flex>
  );
};
